import { useMemo } from 'react'
import useZipcode from 'src/contexto/hooks/useZipcode'
import { ZipcodeAddress } from '../types'
import LoginToViewRegisteredZipcode from './loginToViewRegisteredZipcode'
import { Container, ContainerScroll, Subtitle } from './styles'
import ZipcodeSelector from './zipcodeSelector'

type Props = {
  addresses: ZipcodeAddress[]
  setZipcodeValue: (value: string) => void
  onSubmit: (zipcode: string) => void
  isAuthenticated?: boolean
}

const ZipcodeBox = ({
  addresses,
  setZipcodeValue,
  onSubmit,
  isAuthenticated,
}: Props) => {
  const zipcodeContext = useZipcode()
  const currentAddress = useMemo(() => {
    const selectedAddress = addresses?.find(
      (address) => zipcodeContext.zipcode?.replace('-', '') === address.cep
    )

    if (selectedAddress) {
      return selectedAddress
    }

    if (!zipcodeContext.zipcode?.replace('-', '')) {
      return addresses?.find((address) => address.padrao)
    }
    return undefined
  }, [zipcodeContext.zipcode, addresses])

  return (
    <Container>
      {isAuthenticated && <Subtitle>Escolha um CEP cadastrado</Subtitle>}
      <ContainerScroll>
        {isAuthenticated ? (
          <>
            {addresses?.map((address) => (
              <ZipcodeSelector
                isSelected={currentAddress?.id === address.id}
                key={address.id}
                address={address}
                setZipcodeValue={setZipcodeValue}
                onSubmit={onSubmit}
              />
            ))}
          </>
        ) : (
          <LoginToViewRegisteredZipcode />
        )}
      </ContainerScroll>
    </Container>
  )
}

export default ZipcodeBox
